<script>
	import stockup from './stockup.vue'
	export default {
		extends: stockup,
		data() {
			return {
				notice:'是否达到预警线【备货采购：预警值 = 库存预警下限-在途库存数量-可用库存数量】【应急采购：预警值 = -在途库存数量-可用库存数量】预警值大于0为【是】',
				listref:"stockWarningCustomList",
				customeditHandle:null,
				policytype:0,
				list_columns: [{
						type: 'checkbox',
						title: '#',
						width: 50,
						fixed: 'left'
					},{
						field: 'goodscode',
						title: '商品编码',
						width: 100,
						fixed: 'left'
					},
					{
						field: 'goodsname',
						title: '商品名称',
						width: 100,
					},
					{
						field: 'goodsmodel',
						title: '商品型号',
						width: 100,
					},
					{
						field: 'weight',
						title: '商品重量(kg)',
						width: 100
					},
					{
						field: 'recommendlevel',
						title: '推荐等级',
						sortable:true,
						width: 100
					},
					{
						field: 'policytype',
						title: '策略类型',
						formatter:'policytype',
						width: 100
					},
					{
						field: 'lock',
						title: '锁定库存',
						width: 100
					},
					{
						field: 'quantity',
						title: '实际库存',
						width: 100
					},
					{
						field: 'underway',
						title: '在途库存',
						width: 100
					},
					{
						field: 'availableSize',
						title: '可用库存',
						width: 100
					},
					{
						field: 'warningnum',
						title: '预警值',
						width: 100
					},
					{
						field: 'warehouseid',
						title: '仓库',
						width: 100,
						fixed: 'left',
						formatter:'warehouse'
					},
					{
						field: 'bottom',
						title: '下限',
						width: 100
					},
					{
						field: 'top',
						title: '上限',
						width: 100
					},
					{
						field: 'custombottom',
						title: '自定义下限',
						width: 100
					},
					{
						field: 'customtop',
						title: '自定义上限',
						width: 100
					},
					{
						field: 'suggestnum',
						title: '建议采购数量',
						width: 100
					},
					{
						field: 'buynum',
						title: '近一年购买次数',
						width: 100
					},
					{
						field: 'prochasestandards',
						title: '采购标准',
						width: 100
					},
					{
						field: 'purchasenum',
						title: '本次采购数量',
						sortable:true,
						width: 100,
						fixed: 'right'
					},
					{
						field: 'suppliernameprovince',
						title: '省份',
						width: 100,
						formatter:'city',
						fixed: 'right',
					},
					{
						field: 'purchaseweight',
						title: '本次采购重量(kg)',
						sortable:true,
						width: 100
					},
					{
						field: 'supplierid',
						title: '推荐供应商',
						width: 200,
						sortable:true,
						fixed: 'right',
						formatter:'supplier'
					},
					{
						field: 'getday',
						title: '到仓天数',
						width: 80,
						fixed: 'right',
					},
					{
						field: 'customizedday',
						title: '定做天数',
						fixed: 'right',
						width: 80
					},
					{
						field: 'taxprice',
						title: '采购单价',
						width: 80,
					},
					{
						field: 'taxamount',
						title: '采购金额',
						sortable:true,
						width: 80,
						fixed: 'right'
					},
					{
						field: 'warningline',
						title: '是否达到预警线',
						width: 100,
						sortable:true,
						fixed: 'right',
						slots: {
							default: ({row}) => {
								if(row.warningline == 1){
									return [
										<span style="color:#67C23A" >是</span>
									]
								}else{
									return <span style="color:#F56C6C" >否</span>
								}

							}
						}
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 100,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.delete(row)}} style="color:#F56C6C">删除</el-button>
								]
							}
						}
					}					
				]
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.formConfig = false
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '生成采购单',
						status: 'primary',
						code: 'createpurchase'
					},{
						name: '统计',
						status: 'success',
						code: 'static'
					},{
						name: '导入商品编码',
						status: 'danger',
						dropdowns:[{
							name: 'excle导入',
							code: 'import'
						},{
							name: '从供应商导入',
							code: 'importfromsupplier'
						}],
					},{
						name: '导出',
						status: 'success',
						code: 'export'
					}],
					customConfig: {
						storage: true
					},
					custom: false,
					refresh: true,
					zoom: false,
					tools: []
				}
			},
			importfromsupplier(){
				this.$refs.goodsBox.initList()
				this.$refs.goodsBox.box.alertBox()		
			},
			goodsBoxSubmit(e){
				if(e.data.length){
					this.list_afterImportData(null,e.data)
				}

			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list:[]
					})
				})
			},
			customFormShow(){
				this.$refs.customForm.modal_show()
			},
			customFormHide(){
				this.customeditHandleCall()
			},
			customFormSubmit(e){
				this.customdata = {...this.customdata,...e}
				this.customeditHandleCall()
			},
			customeditHandleCall(){
				if(this.customeditHandle){
					this.customeditHandle()
					this.customeditHandle = null
				}
			},
			// list_beforeImportData(){
			// 	return new Promise((reslove)=>{
			// 		this.customdata = {
			// 			goodscode:[],
			// 			warehouseid:0,
			// 			policytype:0
			// 		}
			// 		this.customFormShow()
			// 		this.customeditHandle = reslove
			// 	})
				
			// },
			list_afterImportData(table,data){
				new Promise((reslove)=>{
					this.customdata = {
						goodscode:[],
						warehouseid:0,
						policytype:0
					}
					if(data.length){						
						let warehouse =  window.systemData.warehouse.find((item)=>{
							return item.name == data[0].warehouseid
						})
						this.customdata.warehouseid = warehouse?warehouse.id:0
						this.customdata.policytype = window.systemMethods.getEmunId('policytype',data[0].policytype)
					}
					this.customFormShow()
					this.customeditHandle = reslove
				}).then(()=>{
					let goodscode = data.map((item)=>{
						return {
							goodscode:item.goodscode
						}
					})
					this.customdata.goodscode = goodscode
					if(!this.customdata.policytype || !this.customdata.warehouseid){
						return
					}
					this.loading = true
					this.$api.stockwarning.custom({data:this.customdata}).then((res) => {
						this.getgrid().reloadData(res)
						this.loading = false
					},()=>{
						this.loading = false
					})
					// console.log(this.customdata)
				})
				
				

			},
			delete(row){
				this.getgrid().remove(row)
			}
		},
		components: {

		}
	}
</script>